import { render, staticRenderFns } from "./VTs.vue?vue&type=template&id=38138539&scoped=true"
import script from "./VTs.vue?vue&type=script&lang=js"
export * from "./VTs.vue?vue&type=script&lang=js"
import style0 from "./VTs.vue?vue&type=style&index=0&id=38138539&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38138539",
  null
  
)

export default component.exports